import React, { useEffect, useState } from 'react';
import {
  Car,
  HouseLine,
  AirplaneTilt,
  Wrench,
  Student,
  Tag,
  HandHeart,
  PiggyBank,
  Briefcase,
  DeviceMobile,
  Heartbeat,
  PawPrint,
  UserCircle,
  DesktopTower,
  ShieldPlus,
  HandCoins,
} from '@phosphor-icons/react';
import {
  Overlay,
  ModalContainer,
  Header,
  Body,
  ColLeft,
  ColCenter,
  ColRight,
  SmallLabel,
  IconsGrid,
  IconButton,
  Icon,
  Row,
  RowInline,
  RowHalf,
  TotalTop,
  Scrollable,
  Invest,
  InvestHeader,
  InvestLabel,
  InvestValue,
  Bar,
  InvestTotal,
  Footer,
  BtnCancel,
  BtnExcluir,
  BtnCreate,
} from './styles';
import axios, { AxiosResponse } from 'axios';
import { IPropsPositionAll } from '../../../../../../utils/@types/wallet';
import { IPropsMattress } from '../../../../../components/Boltz/MyWallet/Mattress/@types';
import { financeRoutes } from '../../../../../../utils/RoutesApi';
import { baseURL } from '../../../../../../utils/baseURL';
import { Slider } from 'antd';
import 'antd/dist/reset.css';

interface ModalCriarBoxProps {
  visible: boolean;
  onClose: () => void;
  editingBox?: any;
  onCreate?: (data: {
    nome: string;
    data: string;
    valorTotal: number;
    valorDestinado: number;
    icon: string | null;
  }) => void;
  selectedObjective?: {
    label: string;
    iconName: string;
  } | null;
}

export interface IPropsAllPosition extends IPropsPositionAll {
  key: string;
}

/**
 * Porcentagem (0–1) do ativo alocada neste box. Sempre relativa ao BRUTO real
 * do ativo (grossTotal = bruto total, antes de descontar boxes) — nunca ao valor
 * disponível. Clampada em [0, 1] para evitar gravar > 1 (que esconderia o ativo
 * indevidamente) por arredondamento ou valor acima do bruto.
 */
function boxAppliedPercentage(value: number, grossTotal: number): number {
  const v = Number(value) || 0;
  const gross = Number(grossTotal) || 0;
  if (gross <= 0 || v <= 0) return 0;
  return Math.min(v / gross, 1);
}

export default function ModalCriarBox({
  visible,
  onClose,
  onCreate,
  selectedObjective,
  editingBox,
}: ModalCriarBoxProps) {
  const [nome, setNome] = useState('');
  const [data, setData] = useState('');
  const [valorTotal, setValorTotal] = useState('');
  const [valorDestinado, setValorDestinado] = useState('');
  const [selectedIcon, setSelectedIcon] = useState<string | null>(null);
  const [totalPatrimonio, setTotalPatrimonio] = useState(0);
  const [investments, setInvestments] = useState<any[]>([]); // agora será populado pela API
  const isEditing = !!editingBox;

  async function updateBoxAPI() {
    try {
      if (!nome.trim()) return alert('Preencha o Nome do Objetivo.');
      if (!data) return alert('Selecione a Data.');
      if (!valorTotal || parseFloat(valorTotal) <= 0)
        return alert('Informe um valor Total Válido.');
      if (!selectedIcon) return alert('Selecione um Ícone.');

      const payload = {
        icon: selectedIcon,
        name: nome,
        total_objective_value: parseFloat(valorTotal) || 0,
        realization_date: data,
        investments: investments
          .filter((i) => i.value > 0)
          .map((i) => ({
            investment_id: i.id,
            box_applied_percentage: boxAppliedPercentage(i.value, i.grossTotal),
          })),
      };

      await axios.put(
        `${baseURL}${financeRoutes.FINANCE_BOX_UPDATE(editingBox.id)}`,
        payload
      );

      onClose();
    } catch (err) {
      console.error(err);
      alert('Erro ao salvar box');
    }
  }

  async function deleteBoxAPI() {
    try {
      await axios.delete(
        `${baseURL}${financeRoutes.FINANCE_BOX_DELETE(editingBox.id)}`
      );
      onClose();
    } catch (err) {
      console.error(err);
      alert('Erro ao excluir box');
    }
  }

  // const objectiveToIconMap = {
  //   'Novo objetivo':'plus',
  //   'Reserva de emergência':'money',
  //   'Novo carro' : 'car',
  //   "Nova casa": "house",
  //   "Nova viagem": "airplane",
  //   "Nova reforma": "wrench",
  //   "Educação": "student",
  //   "Novo sonho de consumo": "tag",
  // }
  // useEffect(()=>{
  //   setSelectedIcon((objectiveToIconMap as any)[selectedObjective as any] as any)
  //   setNome(selectedObjective)
  // },[])

  

  const handleCreate = () => {
    const novo = {
      nome,
      data,
      valorTotal: parseFloat(valorTotal) || 0,
      valorDestinado: parseFloat(valorDestinado) || 0,
      icon: selectedIcon,
    };
    if (onCreate) onCreate(novo);
    setNome('');
    setData('');
    setValorTotal('');
    setValorDestinado('');
    setSelectedIcon(null);
    onClose();
  };

  const icons = [
    { name: 'plus', element: <ShieldPlus fill="#6A717E" /> },
    { name: 'money', element: <PiggyBank fill="#6A717E" /> },
    { name: 'car', element: <Car fill="#6A717E" /> },
    { name: 'house', element: <HouseLine fill="#6A717E" /> },
    { name: 'airplane', element: <AirplaneTilt fill="#6A717E" /> },
    { name: 'wrench', element: <Wrench fill="#6A717E" /> },
    { name: 'student', element: <Student fill="#6A717E" /> },
    { name: 'tag', element: <Tag fill="#6A717E" /> },
    // novos
    { name: 'ring', element: <HandHeart fill="#6A717E" /> },
    { name: 'retirement', element: <UserCircle fill="#6A717E" /> },
    { name: 'chart', element: <HandCoins fill="#6A717E" /> },
    { name: 'briefcase', element: <Briefcase fill="#6A717E" /> },
    { name: 'phone', element: <DeviceMobile fill="#6A717E" /> },
    { name: 'computer', element: <DesktopTower fill="#6A717E" /> },
    { name: 'health', element: <Heartbeat fill="#6A717E" /> },
    { name: 'pet', element: <PawPrint fill="#6A717E" /> },
  ];

  // buscar renda fixa real
  async function getActives() {
    try {
      const response2: AxiosResponse<{ positionsAll: IPropsAllPosition[] }> =
        await axios.get(`${baseURL}${financeRoutes.FINANCE_POSITION}`, {
          params: { show_reserve: true },
        });

      // box_applied_percentage == 1 (100%) => ativo totalmente alocado em boxes,
      // não deve aparecer. Abaixo disso, exibe apenas o valor disponível (livre).
      const FULL = 0.999;

      // criar estrutura para os sliders
      const mapped = (response2.data?.positionsAll || [])
        .filter(
          (item) =>
            item?.productTypeName === 'tesourodireto' ||
            item?.productTypeName === 'rendafixa'
        )
        .filter((item: any) => item?.id)
        .map((item: any) => {
          // Já alocado em todos os boxes
          const applied = Number(item.total_investment_box_applied_value) || 0;
          // manual_update_value é o bruto (gross); updateValue é o net (disponível)
          // Valor bruto total do ativo
          const grossTotal =
            Number(item.manual_update_value) > 0
              ? Number(item.manual_update_value)
              : Number(item.updateValue) + applied || 0;
          // Valor disponível = bruto - alocado em todos os boxes
          const available = grossTotal - applied;

          // Porcentagem já alocada em boxes vem da API; fallback derivado.
          let boxPct = Number(item.box_applied_percentage);
          if (!boxPct || Number.isNaN(boxPct)) {
            boxPct = grossTotal > 0 ? applied / grossTotal : 0;
          }

          return {
            id: item.id,
            label:
              item.tickerSymbol ||
              item.corporationName ||
              item.productTypeName ||
              'Ativo sem nome',
            applied,
            available,
            grossTotal,
            value: 0,
            boxPct,
          };
        });

      setTotalPatrimonio(mapped.reduce((acc, it) => acc + it.grossTotal, 0));

      // só aparecem os ativos que NÃO estão 100% alocados em boxes; o valor
      // exibido é o disponível (livre) e o slider começa zerado.
      const visible = mapped.filter((it) => it.boxPct < FULL);

      if (editingBox?.investments?.length > 0) {
        const matched = new Set<string>(visible.map((it) => String(it.id)));
        const finalList = [...visible];

        // Garante que ativos do box que não vieram em positionsAll (ou foram
        // filtrados por productTypeName) ainda apareçam no modal de edição.
        editingBox.investments
          ?.filter(
            (inv: any) =>
              inv?.position?.id != null &&
              !matched.has(String(inv.position.id))
          )
          .forEach((inv: any) => {
            const pos = inv.position;
            const appliedInThisBox = Number(inv.box_applied_value) || 0;
            const totalAppliedAllBoxes =
              Number(pos?.total_investment_box_applied_value) ||
              appliedInThisBox;
            const grossTotal =
              Number(pos?.manual_update_value) > 0
                ? Number(pos.manual_update_value)
                : Number(pos?.updateValue || 0) + totalAppliedAllBoxes;
            const safeGross = Math.max(grossTotal, appliedInThisBox);

            let boxPct = Number(pos?.box_applied_percentage);
            if (!boxPct || Number.isNaN(boxPct)) {
              boxPct =
                safeGross > 0 ? totalAppliedAllBoxes / safeGross : 0;
            }
            // 100% alocado não aparece.
            if (boxPct >= FULL) return;

            finalList.push({
              id: pos.id,
              label:
                pos?.tickerSymbol ||
                pos?.corporationName ||
                pos?.productTypeName ||
                'Ativo sem nome',
              applied: totalAppliedAllBoxes,
              // Apenas o valor disponível (livre); slider começa zerado.
              available: safeGross - totalAppliedAllBoxes,
              grossTotal: safeGross,
              value: 0,
              boxPct,
            });
          });

        setInvestments(finalList);
      } else {
        setInvestments(visible);
      }
    } catch (err) {
      console.error('Erro ao carregar renda fixa:', err);
    }
  }

  useEffect(() => {
    if (visible) {
      getActives();
    }
  }, [visible]);

  useEffect(() => {
    if (editingBox) {
      setNome(editingBox.name);
      setData(editingBox.realization_date?.split('T')[0]);
      setValorTotal(editingBox.total_objective_value);
      setSelectedIcon(editingBox.icon);
    }
  }, [editingBox]);

  useEffect(() => {
    // só aplica quando for criação (não edição)
    if (!editingBox && selectedObjective) {
      setNome(selectedObjective.label);
      setSelectedIcon(selectedObjective.iconName);
    }
  }, [selectedObjective, editingBox]);

  if (!visible) return null;

  // recalcular total destinado conforme sliders mudam
  const totalDestinado = investments.reduce((acc, it) => acc + it.value, 0);

  const handleSliderChange = (idx: number, newValue: number) => {
    setInvestments((prev) =>
      prev.map((it, i) =>
        i === idx ? { ...it, value: Math.min(newValue, it.available) } : it
      )
    );
  };

  // === CRIAR BOX NA API ===
  async function createBoxAPI() {
    try {
      // --- VALIDAÇÃO DOS CAMPOS OBRIGATÓRIOS ---
      if (!nome.trim()) {
        alert('Preencha o Nome do Objetivo.');
        return;
      }

      if (!data) {
        alert('Selecione a data de realização.');
        return;
      }

      if (!valorTotal || parseFloat(valorTotal) <= 0) {
        alert('Informe um Valor Total válido para o Objetivo.');
        return;
      }

      if (!selectedIcon) {
        alert('Selecione um Ícone para o Objetivo.');
        return;
      }
      // console.log("👀 INVESTMENTS ORIGINAIS:", investments);
      const payload = {
        icon: selectedIcon,
        name: nome,
        total_objective_value: parseFloat(valorTotal) || 0,
        realization_date: data,
        investments: investments
          .filter((it) => it.value > 0) // só envia quem teve valor destinado
          .map((it) => ({
            investment_id: it.id,
            box_applied_percentage: boxAppliedPercentage(it.value, it.grossTotal),
          })),
      };

      // console.log("📦 PAYLOAD ENVIADO PARA O BACKEND:", payload);

      const res = await axios.post(
        `${baseURL}${financeRoutes.FINANCE_BOX_CREATE}`,
        payload
      );

      // permite o componente pai atualizar lista
      if (onCreate) onCreate(res.data);

      // limpar estado
      setNome('');
      setData('');
      setValorTotal('');
      setValorDestinado('');
      setSelectedIcon(null);

      onClose();
    } catch (error) {
      console.error('Erro ao criar box:', error);
      alert('Erro ao criar box. Verifique os dados.');
    }
  }

  return (
    <Overlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <Header>
          {isEditing ? (
            <>
              <h3>Editar Box de objetivos</h3>
            </>
          ) : (
            <h3>Nova Box de objetivos</h3>
          )}
          <button onClick={onClose}>×</button>
        </Header>

        <Body>
          {/* COLUNA ESQUERDA */}
          <ColLeft>
            <RowInline>
              <Row>
                <label>Nome do objetivo</label>
                <input
                  className="input"
                  type="text"
                  value={nome}
                  onChange={(e) => {
                    !!e.target.value && setNome(e.target.value);
                  }}
                  placeholder="Ex: Novo carro"
                />
              </Row>

              <RowHalf>
                <label>Data de realização</label>
                <input
                  type="date"
                  value={data}
                  onChange={(e) => setData(e.target.value)}
                />
              </RowHalf>

              <Row>
                <label>Valor total do objetivo</label>
                <input
                  className="input"
                  type="text"
                  value={
                    'R$ ' +
                    (parseFloat(valorTotal) || 0).toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                    })
                  }
                  onChange={(e) => {
                    const onlyNumbers = e.target.value.replace(/\D/g, '');
                    const numericValue = (Number(onlyNumbers) / 100).toString();
                    setValorTotal(numericValue);
                  }}
                  placeholder="R$ 0,00"
                />
              </Row>
            </RowInline>

            <SmallLabel>Ícone</SmallLabel>
            <IconsGrid>
              {icons.map((ic, i) => (
                <IconButton
                  key={i}
                  type="button"
                  selected={selectedIcon === ic.name}
                  onClick={() => setSelectedIcon(ic.name)}
                >
                  <Icon>{ic.element}</Icon>
                </IconButton>
              ))}
            </IconsGrid>
            {/* <OutrosButton type="button">Outros</OutrosButton> */}
          </ColLeft>

          {/* COLUNA DIREITA */}
          <ColRight>
            <TotalTop>
              <span>Valor destinado</span>
              <strong>
                R${' '}
                {totalDestinado.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })}
              </strong>
            </TotalTop>

            <Scrollable>
              {investments.length === 0 && (
                <p style={{ color: '#888', textAlign: 'center' }}>
                  Carregando ativos...
                </p>
              )}
              {investments.map((it, idx) => {
                const isDisabled = it.available === 0 && it.value === 0;

                return (
                  <Invest
                    key={idx}
                    style={{
                      opacity: isDisabled ? 0.4 : 1,
                      pointerEvents: isDisabled ? 'none' : 'auto',
                    }}
                  >
                    <InvestHeader>
                      <InvestLabel>{it.label}</InvestLabel>
                    </InvestHeader>

                    <ColCenter>
                      <Bar>
                        <Slider
                          min={0}
                          max={it.available}
                          step={1}
                          disabled={isDisabled}
                          style={{ width: '100%' }}
                          value={it.value}
                          onChange={(val) => handleSliderChange(idx, val)}
                          trackStyle={{
                            backgroundColor: isDisabled ? '#ccc' : '#E15533',
                            height: 8,
                            borderRadius: 4,
                          }}
                          handleStyle={{
                            border: '1px solid #E15533', // borda branca para destacar
                            backgroundColor: '#E15533',
                            width: 8, // diâmetro da bolinha
                            height: 50,
                            marginTop: -25, // centraliza verticalmente
                            // borderRadius: "50%", // deixa redonda
                            boxShadow: '0 0 4px rgba(0,0,0,0.3)', // sombra leve
                            zIndex: '999999999',
                          }}
                          railStyle={{
                            backgroundColor: isDisabled ? '#eee' : '#FFE4DE',
                            height: 8,
                            borderRadius: 4,
                          }}
                        />
                      </Bar>

                      <InvestValue>
                        <input
                          type="text"
                          disabled={isDisabled}
                          value={
                            'R$ ' +
                            it.value.toLocaleString('pt-BR', {
                              minimumFractionDigits: 2,
                            })
                          }
                          onChange={(e) => {
                            if (isDisabled) return;

                            const onlyNumbers = e.target.value.replace(
                              /\D/g,
                              ''
                            );
                            const numericValue = Number(onlyNumbers) / 100;

                            handleSliderChange(idx, numericValue);
                          }}
                          style={{
                            width: '100px',
                            border: 'transparent',
                            background: 'transparent',
                            fontSize: '14px',
                            color: isDisabled ? '#aaa' : '#6A717E',
                            cursor: isDisabled ? 'not-allowed' : 'text',
                          }}
                        />
                      </InvestValue>
                    </ColCenter>

                    <InvestTotal>
                      {isDisabled ? (
                        <span style={{ color: '#999', fontStyle: 'italic' }}>
                          Totalmente alocado em outro objetivo
                        </span>
                      ) : (
                        <>
                          Valor disponível: R${' '}
                          {it.available.toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                          })}
                        </>
                      )}
                    </InvestTotal>
                  </Invest>
                );
              })}
            </Scrollable>
          </ColRight>
        </Body>

        <Footer>
          {isEditing ? (
            <>
              <BtnCreate onClick={updateBoxAPI}>Salvar box</BtnCreate>
              <BtnExcluir onClick={deleteBoxAPI}>Excluir objetivo</BtnExcluir>
            </>
          ) : (
            <BtnCreate onClick={createBoxAPI}>Criar</BtnCreate>
          )}
          <BtnCancel onClick={onClose}>Cancelar</BtnCancel>
        </Footer>
      </ModalContainer>
    </Overlay>
  );
}
